<template>
  <div id="app">
    <!-- World Headbar versione SPA -->
    <world-headbar
      @openWorldMenu="worldMenuOpen = !worldMenuOpen"
      :hintFn="searchContacts"
    />
    <vue-progress-bar></vue-progress-bar>
    <!-- Menu laterale di navigazione -->
    <world-menu v-if="!checkingLogin" :menu-open="worldMenuOpen" />
    <!-- Link refresh app -->
    <div class="pwa-refresh-app-banner" v-if="showRefreshPopup">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "A new version of app is available. Refresh the page.",
              "Una nuova versione dell'app è disponibile. Ricarica la pagina."
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <button
            type="button"
            class="com-anm22-button small light-blue"
            @click="pageReload"
          >
            <img :src="$anm22.icons.getWorldIcon('refreshWhite')" />
            <div>{{ $anm22.strLang(lang, "Refresh", "Ricarica") }}</div>
          </button>
        </div>
      </div>
    </div>
    <!-- Router View, contenitore per il rendering dei componenti in fase di navigazione -->
    <div
      class="com-anm22-app-outer-wrapper"
      @click="
        'void(0);';


      "
      :style="$route.path === '/login' ? 'padding-left:0;' : ''"
    >
      <div v-if="checkingLogin" class="wg-row" style="justify-content:center;">
        <div class="vertical-height-div" style="height:40px;"></div>
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Logging in...", "Accesso in corso...") }}
        </div>
      </div>
      <router-view v-else></router-view>
    </div>
    <footer
      v-if="!userLogged"
      style="position:fixed; left:0; bottom:0; border-top: 1px #efefef solid; background-color:#FFF; z-index:1000; width:100%;"
    >
      <div style="font-size:14px; color:#999; padding:5px 20px;">
        ANM22 World -
        <a href="https://www.anm22.it/it/privacy-policy/" style="color:#666;"
          >Privacy Policy</a
        >
        -
        <a href="https://www.anm22.it/it/cookies/" style="color:#666;"
          >Cookie Policy</a
        >
      </div>
    </footer>
    <portal-target name="anm22-portal-modal" multiple>
      <!--
      Destinazione per il render dei modali
      -->
    </portal-target>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldHeadbar from "../../../world/spa/components/WorldHeadbar.vue";
import WorldMenu from "../../../world/spa/components/WorldMenu.vue";
import { PortalTarget } from "portal-vue";

export default {
  data() {
    return {
      worldMenuOpen: false,
      showRefreshPopup: false,
      loadedPlugins: [],
      loadedTasksPlugin: [],
      regionsFilter: [
        "Abruzzo",
        "Basilicata",
        "Calabria",
        "Campania",
        "Emilia-Romagna",
        "Friuli-Venezia Giulia",
        "Lazio",
        "Liguria",
        "Lombardia",
        "Marche",
        "Molise",
        "Piemonte",
        "Puglia",
        "Sardegna",
        "Sicilia",
        "Toscana",
        "Trentino-Alto Adige",
        "Umbria",
        "Valle d'Aosta",
        "Veneto",
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      userLogged: (state) => state.auth.userLogged,
      workSelected: (state) => state.workSelected,
      checkingLogin: (state) => state.auth.checkingLogin,
    }),
    userPermission() {
      if (this.userLogged) {
        return this.$store.getters["employments/getPermByWork"](
          this.workSelected
        );
      }
    },
    licenses() {
      if (this.userLogged) {
        return this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        ).map((e) => this.$store.getters["licenses/getByWork"](e.work));
      }
    },
    contactsMenu() {
      let menu = [
        {
          items: [
            {
              name: "tasks",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuTasks"),
              iconHover: this.$anm22.icons.getWorldIcon("menuTasksGreen"),
              description: "Tasks",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://tasks.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/tasks-v/",
              selectId: "tasks",
            },
            {
              name: "calendar",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuCalendar"),
              iconHover: this.$anm22.icons.getWorldIcon("menuCalendarRed"),
              description: "Calendar",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://calendar.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/calendar-v/",
              selectId: "calendar",
            },
            {
              name: "contacts",
              external: false,
              icon: this.$anm22.icons.getWorldIcon("menuContacts"),
              iconHover: this.$anm22.icons.getWorldIcon("menuContactsBlue"),
              description: "Contacts",
              href: "/",
              selectId: "contacts",
            },
            {
              name: "pay",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuWallet"),
              iconHover: this.$anm22.icons.getWorldIcon("menuWalletBrown"),
              description: "Pay",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://www.anm22.it/app/pay/"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/pay/",
              selectId: "pay",
            },
            {
              name: "inbox",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("inbox"),
              description: "Inbox",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://inbox.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/inbox-v/",
              selectId: "inbox",
            },
            {
              name: "resource",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuResource"),
              iconHover: this.$anm22.icons.getWorldIcon("menuResourceYellow"),
              description: "Resource",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://resource.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/resource-v/",
              selectId: "resource",
            },
          ],
        },
        {
          items: [
            {
              name: "settings",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuSettings"),
              description: this.$anm22.strLang(
                this.lang,
                "Settings",
                "Impostazioni"
              ),
              href:
                process.env.NODE_ENV === "production"
                  ? "https://www.anm22.it/app/work/settings"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/work/settings",
              selectId: "settings",
            },
            {
              name: "switch",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuSwitch"),
              description: this.$anm22.strLang(
                this.lang,
                "Change company",
                "Cambia azienda"
              ),
              selectId: "switch",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://www.anm22.it/app/work/selectWork?cbSucc=" +
                    encodeURIComponent("https://contacts.anm22.it")
                  : process.env.VUE_APP_FRONT_DOMAIN +
                    "/app/work/selectWork?nullOption=1&cbSucc=" +
                    encodeURIComponent("../contacts-v/"),
            },
            {
              name: "help",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuHelp"),
              description: this.$anm22.strLang(this.lang, "Help", "Aiuto"),
              href: "https://www.anm22.it/it/tasks-tutorial/",
              selectId: "help",
            },
          ],
        },
      ];
      if (this.workSelected == 474 && this.userPermission <= 3) {
        menu[0].items.push({
          name: "administration",
          external: true,
          icon: this.$anm22.icons.getWorldIcon("menuAdmin"),
          description: this.$anm22.strLang(
            this.lang,
            "Administration",
            "Amministrazione"
          ),
          href:
            process.env.NODE_ENV === "production"
              ? "https://www.anm22.it/app/work/link-administration"
              : process.env.VUE_APP_FRONT_DOMAIN +
                "/app/work/link-administration",
          selectId: "administration",
        });
      }
      if (
        this.workSelected == 1 ||
        this.workSelected == 2 ||
        this.workSelected == 16 ||
        this.workSelected == 965
      ) {
        menu[0].items.push({
          name: "warehouse",
          external: true,
          icon: this.$anm22.icons.getWorldIcon("menuWarehouse"),
          iconHover: this.$anm22.icons.getWorldIcon("menuWarehouseYellow"),
          description: this.$anm22.strLang(this.lang, "Warehouse", "Magazzino"),
          href:
            process.env.NODE_ENV === "production"
              ? "https://tasks.anm22.it/warehouse"
              : process.env.VUE_APP_FRONT_DOMAIN + "/app/tasks-v/warehouse",
          selectId: "warehouse",
        });
      }
      return menu;
    },
    ybMenu() {
      return [
        {
          items: [
            {
              name: "beach",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuBeach"),
              iconHover: this.$anm22.icons.getWorldIcon("menuBeachBlue"),
              description: this.$anm22.strLang(this.lang, "Beach", "Spiaggia"),
              href: process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/",
              selectId: "beach",
            },
            {
              name: "prices",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuTable"),
              iconHover: this.$anm22.icons.getWorldIcon("menuTableGreen"),
              description: this.$anm22.strLang(this.lang, "Prices", "Listini"),
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/prices.php",
              selectId: "prices",
            },
            {
              name: "fc",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuRegister"),
              iconHover: this.$anm22.icons.getWorldIcon("menuRegisterGrey"),
              description: this.$anm22.strLang(
                this.lang,
                "Fast cash",
                "Cassa rapida"
              ),
              href:
                process.env.VUE_APP_FRONT_DOMAIN +
                "/app/yourbeach/fast_cash.php",
              selectId: "fc",
            },
            {
              name: "stats",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuAnalytics"),
              iconHover: this.$anm22.icons.getWorldIcon("menuanalyticsOrange"),
              description: this.$anm22.strLang(
                this.lang,
                "Analytics",
                "Statistiche"
              ),
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/prices.php",
              selectId: "analytics",
            },
            {
              name: "weather",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuWeather"),
              iconHover: this.$anm22.icons.getWorldIcon("menuWeatherBlue"),
              description: this.$anm22.strLang(this.lang, "Weather", "Meteo"),
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/weather.php",
              selectId: "weather",
            },
            {
              name: "calendar",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuCalendar"),
              iconHover: this.$anm22.icons.getWorldIcon("menuCalendarRed"),
              description: this.$anm22.strLang(
                this.lang,
                "Calendar",
                "Calendario"
              ),
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/events.php",
              selectId: "calendar",
            },
            {
              name: "customers",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuContacts"),
              iconHover: this.$anm22.icons.getWorldIcon("menuContactsBlue"),
              description: this.$anm22.strLang(
                this.lang,
                "Customers",
                "Clienti"
              ),
              href:
                process.env.VUE_APP_FRONT_DOMAIN +
                "/app/yourbeach/usersManager.php",
              selectId: "customers",
            },
            {
              name: "qr",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuQrCode"),
              description: "QR Scan",
              href:
                "https://www.anm22.it/app/yourbeach/scan/?cb=javascript%3Ahistory.go%28-1%29",
              selectId: "qr",
            },
            {
              name: "food",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuFood"),
              iconHover: this.$anm22.icons.getWorldIcon("menuFoodYellow"),
              description: "Food",
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/prices.php",
              selectId: "food",
            },
          ],
        },
        {
          items: [
            {
              name: "settings",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuSettings"),
              description: this.$anm22.strLang(
                this.lang,
                "Settings",
                "Impostazioni"
              ),
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/setting.php",
              selectId: "settings",
            },
            {
              name: "switch",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuSwitch"),
              description: this.$anm22.strLang(
                this.lang,
                "Switch beach",
                "Cambia spiaggia"
              ),
              href:
                process.env.VUE_APP_FRONT_DOMAIN +
                "/app/yourbeach/YBSelectBeach.php",
              selectId: "switch",
            },
            {
              name: "help",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuHelp"),
              description: this.$anm22.strLang(
                this.lang,
                "Settings",
                "Impostazioni"
              ),
              href: "https://www.anm22.it/it/yourbeach-tutorial/",
              selectId: "help",
            },
            {
              name: "logout",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuLogin"),
              description: this.$anm22.strLang(this.lang, "Logout", "Logout"),
              href:
                process.env.VUE_APP_FRONT_DOMAIN + "/app/yourbeach/logout.php",
              selectId: "logout",
            },
          ],
        },
      ];
    },
    foodMenu() {
      return [];
    },
    allPricing() {
      return this.$store.getters["paglieraniContactPricing/getAll"];
    },
  },
  methods: {
    pageReload() {
      location.reload();
    },
    othersContactsEmail(contact) {
      if (contact.otherContacts && contact.otherContacts.emails) {
        if (Array.isArray(contact.otherContacts.emails)) {
          return contact.otherContacts.emails.filter((e) => e && e.address);
        } else {
          console.log(
            "Contact " +
              contact.idContactsContact +
              ": Invalid secondary email addresses array format"
          );
        }
      }
      return [];
    },
    otherContactsPhone(contact) {
      if (contact.otherContacts && contact.otherContacts.phones) {
        if (Array.isArray(contact.otherContacts.phones)) {
          return contact.otherContacts.phones.filter(
            (p) => p && p.phoneAreaCode && p.phoneNumber
          );
        } else {
          console.log(
            "Contact " +
              contact.idContactsContact +
              ": Invalid secondary phones array format"
          );
        }
      }
      return [];
    },
    searchContacts(string, remote = true) {
      let results = [];
      /* Ricerca contatti per nome */
      let contacts = this.$store.getters["contacts/getAll"];
      var reg = new RegExp(string, "i");
      contacts
        .filter((c) => {
          let resPhones = this.otherContactsPhone(c).filter(function(p) {
            return reg.test(p.phoneNumber);
          });
          let resEmails = this.othersContactsEmail(c).filter(function(e) {
            return reg.test(e.address);
          });
          return (
            c.deleted != 1 &&
            (c.idContactsContact == parseInt(string) ||
              -1 !==
                (c.firstName + " " + c.lastName).search(
                  new RegExp(string, "i")
                ) ||
              (c.company && -1 !== c.company.search(new RegExp(string, "i"))) ||
              (c.pec && -1 !== c.pec.search(new RegExp(string, "i"))) ||
              (c.vatCode && -1 !== c.vatCode.search(new RegExp(string, "i"))) ||
              (typeof c.referrerFirstName != "undefined" &&
                typeof c.referrerLastName != "undefined" &&
                -1 !==
                  (c.referrerFirstName + " " + c.referrerLastName).search(
                    new RegExp(string, "i")
                  )) ||
              (c.phoneNumber &&
                -1 !== c.phoneNumber.search(new RegExp(string, "i"))) ||
              (c.email && -1 !== c.email.search(new RegExp(string, "i"))) ||
              // this.searchInOtherInformations(c.otherInformations, string) ||
              resPhones.length > 0 ||
              resEmails.length > 0)
          );
        })
        .map((c) => {
          return {
            label: this.$anm22.getContactName(c, this.$store),
            img:
              c.type == 2
                ? this.$anm22.getObjIcon(c, "workMaterial")
                : this.$anm22.getContactIcon(c, this.$store),
            submitFn: () => {
              this.$router.push({ path: `/contact/${c.idContactsContact}` });
            },
          };
        })
        .forEach((c) => results.push(c));
      /* Ricerca tag */
      let tags = this.$store.getters["tags/getAll"];
      tags
        .filter((t) => -1 !== t.label.search(new RegExp(string, "i")))
        .map((t) => {
          return {
            label: t.label,
            img: this.$anm22.icons.getWorldIcon("tag"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: t.label,
                fn: (c) => c.workOwner && c.tags.includes(t.idWorldTag),
              });
            },
          };
        })
        .forEach((t) => results.push(t));
      /* Ricerca contatti per referente */
      let referents = this.$store.getters["contacts/getAll"]
        .map((c) => this.$store.getters["users/get"](c.referenceAgent))
        .filter((agent) => agent)
        .filter(
          (user, index, arrayResult) =>
            arrayResult.findIndex((r) => r.idWorldUser === user.idWorldUser) ===
            index
        );
      referents
        .filter(
          (ref) =>
            -1 !==
            (ref.name + " " + ref.surname).search(new RegExp(string, "i"))
        )
        .map((ref) => {
          return {
            label: ref.name + " " + ref.surname + " CR",
            img: this.$anm22.icons.getWorldIcon("agent"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: ref.name + " " + ref.surname,
                fn: (c) => c.workOwner && c.referenceAgent == ref.idWorldUser,
              });
            },
          };
        })
        .forEach((ref) => results.push(ref));
      /* Ricerca contatti per screenSales agent */
      let screenSalseAgents = this.$store.getters["contacts/getAll"]
        .map((c) => this.$store.getters["users/get"](c.screenSalesAgent))
        .filter((agent) => agent)
        .filter(
          (user, index, arrayResult) =>
            arrayResult.findIndex((r) => r.idWorldUser === user.idWorldUser) ===
            index
        );
      screenSalseAgents
        .filter(
          (ref) =>
            -1 !==
            (ref.name + " " + ref.surname).search(new RegExp(string, "i"))
        )
        .map((ref) => {
          return {
            label: ref.name + " " + ref.surname + " SS",
            img: this.$anm22.icons.getWorldIcon("agent"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: ref.name + " " + ref.surname,
                fn: (c) => c.workOwner && c.screenSalesAgent == ref.idWorldUser,
              });
            },
          };
        })
        .forEach((ref) => results.push(ref));
      // Ricerca canali
      let channels = this.$store.getters["contactsLeadChannel/getAll"];
      if (!channels.find((c) => c.idContactsContactLeadChannel == 0)) {
        channels.push({
          idContactsContactLeadChannel: 0,
          name: "Nessun canale",
        });
      }
      channels
        .filter((c) => -1 !== c.name.search(new RegExp(string, "i")))
        .map((channel) => {
          return {
            label: channel.name,
            img: this.$anm22.icons.getWorldIcon("flightLand"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: channel.name,
                fn: (c) =>
                  channel.idContactsContactLeadChannel == 0
                    ? !c.leadChannel || c.leadChannel == ""
                    : c.leadChannel === channel.idContactsContactLeadChannel,
              });
            },
          };
        })
        .forEach((channel) => results.push(channel));
      // Ricerca motivi abbandono
      let abandoned = this.$store.getters["contactsAbandoned/getAll"];
      abandoned
        .filter((a) => -1 !== a.name.search(new RegExp(string, "i")))
        .map((a) => {
          return {
            label: a.name,
            img: this.$anm22.icons.getWorldIcon("abandoned"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: a.name,
                fn: (c) => c.abandoned === a.idContactsContactAbandoned,
              });
            },
          };
        })
        .forEach((abandoned) => results.push(abandoned));
      // Ricerca regioni
      let regions = this.regionsFilter;
      regions
        .filter((a) => -1 !== a.search(new RegExp(string, "i")))
        .map((a) => {
          return {
            label: a,
            img: this.$anm22.icons.getWorldIcon("placeBlack"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: a,
                fn: (c) =>
                  c.otherInformations &&
                  c.otherInformations.addressRegion &&
                  c.otherInformations.addressRegion === a,
              });
            },
          };
        })
        .forEach((abandoned) => results.push(abandoned));
      // Ricerca per stato
      const statuses = [
        ...this.$store.getters["contactsStatus/getAll"],
        {
          idContactsContactStatus: "",
          name: "Nessuno stato",
        },
      ];
      statuses
        .filter((status) => -1 !== status.name.search(new RegExp(string, "i")))
        .map((status) => {
          return {
            label: status.name,
            img: this.$anm22.icons.getWorldIcon("contactStatus"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: status.name,
                fn: (c) =>
                  c.workOwner && c.status == status.idContactsContactStatus,
              });
            },
          };
        })
        .forEach((status) => results.push(status));

      /* Ricerca per aziende */
      let works = this.$store.getters["employments/getByUser"](
        this.user.idWorldUser
      ).map((e) => this.$store.getters["works/get"](e.work));
      //let works = this.$store.getters["employments/getWorks"];
      works
        .filter((w) => -1 !== w.name.search(new RegExp(string, "i")))
        .map((w) => {
          return {
            label: w.name,
            img: this.$anm22.getObjIcon(w, "workDefault"),
            submitFn: () => {
              this.$anm22.eventBus.$emit("contacts-filter", {
                name: w.name,
                fn: (c) => c.workOwner && c.workOwner === w.idWorldWork,
              });
            },
          };
        })
        .forEach((w) => results.push(w));
      /** Metodi custom */
      this.licenses.forEach((l) => {
        if (
          l &&
          l.config &&
          l.config.contacts &&
          l.config.contacts.search &&
          l.config.contacts.search["custom-function"]
        ) {
          //console.log(l.config.contacts.search['custom-function']);
          results = results.concat(
            this.$anm22[l.config.contacts.search["custom-function"]](
              this,
              string
            )
          );
        }
      });
      /* search extra contacts */
      if (remote && this.workSelected) {
        this.$http
          .post(
            "contacts/search",
            {
              work: this.workSelected,
              string: string,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            if (response.data) {
              Promise.all([
                this.$store.dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: response.data.contacts,
                }),
              ]).then(() => {
                // Reload search, without remote request (to avoid a loop)
                this.searchContacts(string, false);
              });
            }
          });
      }
      return results;
    },
    searchInOtherInformations(otherInformation, string) {
      if (!otherInformation || Object.keys(otherInformation).length === 0) {
        return false;
      }
      if (
        (typeof otherInformation.addressCity == "undefined" ||
          -1 ===
            otherInformation.addressCity.search(new RegExp(string, "i"))) &&
        (typeof otherInformation.addressState == "undefined" ||
          -1 ===
            otherInformation.addressState.search(new RegExp(string, "i"))) &&
        (typeof otherInformation.addressRegion == "undefined" ||
          -1 ===
            otherInformation.addressRegion.search(new RegExp(string, "i"))) &&
        ((typeof otherInformation.addressStreet == "undefined" &&
          typeof otherInformation.addressNumber == "undefined") ||
          -1 ===
            (
              otherInformation.addressStreet +
              " " +
              otherInformation.addressNumber
            ).search(new RegExp(string, "i")))
      ) {
        return false;
      }

      return true;
    },
  },
  components: {
    WorldHeadbar,
    WorldMenu,
    PortalTarget,
  },
  created() {
    this.$store.dispatch("headbar/enableSearchbar");
    let w = this.$anm22.getCookie("anm22_work");
    if (w !== "") {
      this.$store.dispatch("setWorkSelected", w === "my" ? w : Number(w));
    }
    /* Menu categories and elements */
    this.$store.dispatch("menu/setCategories", this.contactsMenu);
    // Service worker updated event
    window.addEventListener("content-updated", () => {
      this.showRefreshPopup = true;
    });
    // Service worker offline sync event
    if ("serviceWorker" in navigator) {
      // Handler for messages coming from the service worker
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data.type === "sync-data") {
          event.data.objs.forEach((d) => {
            if (d.old.type === "new" || d.old.type === "edit") {
              this.$store.dispatch(d.table + "/update", {
                vlf: this.$vlf(d.table),
                objs: [d.obj],
              });
              if (d.old.type === "new") {
                if (
                  d.old.obj.idContactsContact ===
                  this.$store.getters["getSelectedContact"]
                ) {
                  this.$store.dispatch(
                    "selectContact",
                    d.obj.idContactsContact
                  );
                }
                this.$store.dispatch(d.table + "/delete", {
                  vlf: this.$vlf(d.table),
                  obj: d.old.obj,
                });
              }
            }
          });
        }
      });
    }
    // [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    /* Food or Yourbeach cookie verification */
    if (this.$anm22.getCookie("yb_contacts_menu") !== "") {
      ybLicense = this.$anm22.getCookie("yb_contacts_menu");
      // Update menu with YB elements
      this.$store.dispatch("menu/setCustomMode", {
        href: "https://www.anm22.it/app/yourbeach/",
        icon:
          "https://www.anm22.it/app/yourbeach/images/logos/" +
          ybLicense +
          ".png",
        name: ybLicense,
      });
      this.$store.dispatch("menu/setCategories", this.ybMenu);
    }
    if (this.$anm22.getCookie("fd_contacts_menu") !== "") {
      this.customMenuWork = this.$anm22.getCookie("fd_contacts_menu");
      //Aggiorno in menu con quello di food
    }
  },
  mounted() {
    this.$store.dispatch("updateDimensions", {
      width: window.innerWidth,
      height: window.innerHeight,
    });
    this.$nextTick(() => {
      window.addEventListener(
        "resize",
        _.debounce(() => {
          this.$store.dispatch("updateDimensions", {
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }, 500)
      );
    });
  },
  watch: {
    licenses(newVal, old) {
      // Carico librerie di configurazione specifiche per le licenze di Tasks in uso
      this.licenses.forEach((l) => {
        if (
          l &&
          l.config.contacts &&
          l.config.contacts.plugin &&
          !this.loadedPlugins.includes(l.config.contacts.plugin)
        ) {
          import("../libs/custom/" + l.config.contacts.plugin + ".js").then(
            (lib) => {
              console.log(lib.default);
              Object.assign(this.$anm22, lib.default);
              this.loadedPlugins.push(l.config.contacts.plugin);
              // init plugin
              this.$anm22[l.config.contacts.plugin + "_init"](this);
            }
          );
        }
      });
      this.licenses.forEach((l) => {
        if (
          l &&
          l.config.tasks &&
          l.config.tasks.plugin &&
          !this.loadedTasksPlugin.includes(l.config.tasks.plugin)
        ) {
          import(
            "../../../tasks/spa/libs/custom/" + l.config.tasks.plugin + ".js"
          ).then((lib) => {
            Object.assign(this.$anm22, lib.default);
            this.loadedTasksPlugin.push(l.config.tasks.plugin);
            // init plugin
            this.$anm22[l.config.tasks.plugin + "_init"](this);
          });
        }
      });
    },
    userPermission(newVal, old) {
      this.$store.dispatch("menu/setCategories", this.contactsMenu);
    },
  },
};
</script>

<style lang="scss"></style>
